import CourseItemService from '@/services/CourseItemService.js';

export default {
    namespaced: true,

    state: () => ({
        selectedItems: [],
        selectionType: null, // 'activity' | 'section' | 'week' | 'mixed'
        isMultiSelectMode: false,
        multiChangeMenuOpen: false,
        lastMoveOperation: null,
    }),

    getters: {
        selectionCount: state => state.selectedItems.length,
    },

    mutations: {
        SET_SELECTED_ITEMS(state, items) {
            state.selectedItems = items;
            state.isMultiSelectMode = items.length > 0;
        },
        SET_SELECTION_TYPE(state, type) {
            state.selectionType = type;
        },
        TOGGLE_MULTI_SELECT_MODE(state) {
            state.isMultiSelectMode = !state.isMultiSelectMode;
        },
        OPEN_MULTI_CHANGE_MENU(state) {
            state.multiChangeMenuOpen = true;
            state.isMultiSelectMode = true;
        },
        CLOSE_MULTI_CHANGE_MENU(state) {
            state.multiChangeMenuOpen = false;
        },
        CLEAR_SELECTION(state) {
            state.selectedItems = [];
            state.selectionType = null;
            state.multiChangeMenuOpen = false;
        },
        SET_LAST_MOVE_OPERATION(state, operation) {
            state.lastMoveOperation = operation;
        },
        CLEAR_LAST_MOVE_OPERATION(state) {
            state.lastMoveOperation = null;
        },
    },

    actions: {
        selectItems({ commit }, { items, type }) {
            commit('SET_SELECTED_ITEMS', items);
            commit('SET_SELECTION_TYPE', type);
            if (items.length > 0) {
                commit('OPEN_MULTI_CHANGE_MENU');
            }
        },
        async moveItems({ state, dispatch }, { courseId, targetType, targetId }) {
            await CourseItemService.moveItems(courseId, state.selectionType, state.selectedItems, targetType, targetId);
            dispatch('clearSelection');
        },
        async copyItems({ state, dispatch }, { courseId, targetType, targetId }) {
            await CourseItemService.copyItems(courseId, state.selectionType, state.selectedItems, targetType, targetId);
            dispatch('clearSelection');
        },
        async deleteItems({ state, dispatch }, { courseId }) {
            await CourseItemService.deleteItems(courseId, state.selectionType, state.selectedItems);
            dispatch('clearSelection');
        },
        async undoLastMove({ state, commit }) {
            if (!state.lastMoveOperation) {
                throw new Error('No move operation to undo');
            }

            await CourseItemService.undoMoveItems(state.lastMoveOperation.courseId, state.lastMoveOperation);
            commit('CLEAR_LAST_MOVE_OPERATION');
        },
        clearSelection({ commit }) {
            commit('CLEAR_SELECTION');
        },
    },
};
